import { authFetch } from "utils";

export const getAll = (assetID) =>
  authFetch(`${apiUrl}${version}/assets/${assetID}/deals?t=${new Date().getTime()}`, {
    method: "GET",
  });

export const update = (assetDeal) =>
  authFetch(`${apiUrl}${version}/asset_deals/${assetDeal.id}`, {
    method: "PATCH",
    json: { assetDeal },
  });

export const exportAssetDeals = (assetID) =>
  authFetch(`${apiUrl}${version}/assets/${assetID}/deals/export`, {
    method: "GET",
  });
